export default "__VITE_PUBLIC_ASSET__21cd79bb__"